import React, { useEffect , useContext } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 90: 法規制用のマーカー
 *
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {
  
  const { state } = useContext(Context);

  const icon = menu2icon[option.id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    let ret = []
    ret.push(<h3>【規制項目区分】</h3>)

    const dataset = state.data_for_90.data["vis_90_3"]

    let contents = [];
    
    if (dataset) {
      // レイヤー名を出力
      ret.push(<dl className='dl-list is-modal-spot'><dd><a href={dataset.url} target={"_blank"}>{dataset.dataset_name}</a></dd></dl>)
    }
    
    ret.push(<p>法令名をクリックすると，規制の内容や手続き方法の確認画面に移動します<br />※ 急傾斜地の崩壊による災害の防止に関する法律のみを表示しています。</p>)

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
